declare const PACKAGE_VERSION: string;
// webpack.DefinePlugin
const _PACKAGE_VERSION = PACKAGE_VERSION;

declare global {
  interface Promise<T> { abort?(): void; }
}

export { _PACKAGE_VERSION as PACKAGE_VERSION };

